import { render, staticRenderFns } from "./CourseSkills.vue?vue&type=template&id=213f347c&scoped=true&"
import script from "./CourseSkills.vue?vue&type=script&lang=js&"
export * from "./CourseSkills.vue?vue&type=script&lang=js&"
import style0 from "./CourseSkills.vue?vue&type=style&index=0&id=213f347c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f347c",
  null
  
)

export default component.exports